'use client'

import { memo } from 'react'

import { ErrorDataUnavailable } from '@/components/common/Error'

const VaultV2ChartSharePriceError = () => {
  return <ErrorDataUnavailable minHeight="395px" />
}

export default memo(VaultV2ChartSharePriceError)
